import React from 'react';

const linkTo = (href, text) =>
  text ? (
    <a href={href} style={{ color: '#1a73c8', textDecoration: 'underline' }}>
      {text}
    </a>
  ) : (
    <span>—</span>
  );

const rolePermissionConfig = {
  name: 'Role Permission',
  endpoint: '/internal_admin/admin_kit/role_permissions',
  modelKey: 'rbac_role_permission',

  columns: [
    { name: 'role_name', title: 'Role', type: 'link' },
    { name: 'permission_name', title: 'Permission' },
    { name: 'created_by_name', title: 'Created By' },
    { name: 'created_at', title: 'Created' },
  ],

  filters: [
    { name: 'q[role_name_cont]', label: 'Role' },
    { name: 'q[permission_name_cont]', label: 'Permission' },
  ],

  attributes: [
    { name: 'id', label: 'ID' },
    {
      name: 'role_name',
      label: 'Role',
      render: (r) =>
        linkTo(`/internal_admin/admin_kit/roles/${r.role_id}`, r.role_name),
    },
    { name: 'permission_name', label: 'Permission' },
    { name: 'created_by_name', label: 'Created By' },
    { name: 'created_at', label: 'Created At' },
    { name: 'updated_at', label: 'Updated At' },
  ],

  form: {
    fields: [
      {
        name: 'role_id',
        label: 'Role',
        type: 'typeahead',
        searchEndpoint:
          '/internal_admin/admin_kit/role_permissions/role_search',
        displayField: 'role_name',
        required: true,
      },
      {
        name: 'permission_id',
        label: 'Permission',
        type: 'typeahead',
        searchEndpoint:
          '/internal_admin/admin_kit/role_permissions/permission_search',
        displayField: 'permission_name',
        required: true,
      },
    ],
  },
};

export default rolePermissionConfig;
